"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classnames = classnames;
const classListFromObject = (record) => Object.entries(record).map(([key, value]) => value && key);
const isTruthy = (v) => !!v;
const isUnique = (v, i, a) => a.indexOf(v) === i;
const emptyArray = [];
function classnamesToArray(value) {
    if (!value)
        return emptyArray;
    if (typeof value === "string")
        return [value];
    if (Array.isArray(value))
        return value.flatMap(classnamesToArray).filter(isTruthy);
    return classListFromObject(value).filter(isTruthy);
}
function classnames(value) {
    const list = classnamesToArray(value).filter(isUnique);
    return list.length > 0 ? list.join(" ") : undefined;
}
